// src/components/helpers/FormGroup.js
import React, { memo } from "react";

function FormGroupComponent({ label, children, className }) {
  // console.log("FormGroup: className", className);
  return (
    <div className={`form-group ${className || ""}`}>
      {label && (
        <label className={`bold-text${className ? "-row-50" : ""}`}>
          {label}
        </label>
      )}
      {children}
    </div>
  );
}

export default memo(FormGroupComponent);
